const mandatoryFields = [];

export default mandatoryFields;
